import { GET_CERTIFICATES, ADD_CERTIFICATE, GET_CERTIFICATE_STATUS, UPDATE_QUESTION, UPDATE_CERTIFICATE, DELETE_CERTIFICATE, GET_QUESTION_ANSWER, GET_CERTIFICATE_DOWNLOAD, CLEAR_QUESTIONS_DATA, CLEAR_STATUS_DATA } from "redux/admin-constants";

const initialState = {
  certificatesList: [],
  manageCertificate: [],
  certificationStatusData: [],
  questionsChangeData:[],
  updateCertificateData:[],
  questionsAnswerData:[],
  downloadData:[]
};


const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CERTIFICATES: {
      return {
        ...state,
        certificatesList: payload,
      };
    }

        case ADD_CERTIFICATE: {
          return {
            ...state, 
            manageCertificate:payload,
          }
        }
    case GET_CERTIFICATE_STATUS: {
      return {
        ...state,
        certificationStatusData: payload,
      };
    }

        case UPDATE_QUESTION: {
      return {
        ...state,
        questionsChangeData: payload,
      };
    }

    case UPDATE_CERTIFICATE: {
      return {
        ...state,
        updateCertificateData: payload,
      };
    }
case DELETE_CERTIFICATE: {
  return {
    ...state,
    certificatesList: state.certificatesList.map((item) =>
      item.certificationid === parseInt(payload.certificationid)
        ? {
            ...item,
            certificationstatus:
              payload.status === 9
                ? 1
                : payload.status === 0
                ? 0
                : item.certificationstatus
          }
        : item
    ),
  };
}

    case GET_QUESTION_ANSWER: {
      return {
        ...state,
        questionsAnswerData: payload,
      };
    }

    
    case GET_CERTIFICATE_DOWNLOAD: {
      return {
        ...state,
        downloadData: payload,
      };
    }

    case CLEAR_QUESTIONS_DATA:
  return {
    ...state,
    questionsAnswerData: [],
  };
case CLEAR_STATUS_DATA:
  return {
    ...state,
    certificationStatusData: [],
  };


        default:
      return state;
  }
};
export default reducer; 